import { Type as T } from '@sinclair/typebox';
import { Value } from '@sinclair/typebox/value';
import { validateField } from '../index.js';

export const EditRoleSchema = T.Object({
  uuid: T.String({ format: 'uuid', error: 'Uuid do cargo é um campo obrigatório' }),
  name: T.String({ minLength: 1, error: 'Nome do cargo é um campo obrigatório' }),
  permissions: T.Array(T.String({ format: 'uuid' }), {
    error: 'Permissão deve ser um uuid',
  }),
  hierarchy: T.Integer({ error: 'Posição na hierarquia é uma campo obrigatório' }),
});

export type EditRoleInputType = typeof EditRoleSchema.static;

export async function ValidateEditRoleInput(value: unknown): Promise<EditRoleInputType> {
  return Value.Parse(EditRoleSchema, value);
}

export function checkRoleEditInput(field: string, value: unknown): string | boolean {
  return validateField(EditRoleSchema, field, value);
}
